// API configuration

// API Gateway URL
if (!import.meta.env.VITE_API_BASE_URL) {
  console.error('VITE_API_BASE_URL is not set. Set it in .env.production before building.');
}
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');

// Application configuration
export const APP_CONFIG = {
  name: 'Cloud Cost Optimization & Reporting',
  company: 'CloudCOR',
  supportEmail: 'support@cloudcor.com',
  sourceRepoUrl: import.meta.env.VITE_SOURCE_REPO_URL || 'https://github.com/jsseidel/cloudcor'
};

// Auth configuration
export const AUTH_CONFIG = {
  enabled: true, // Enable authentication features
  samlEnabled: true, // Enable SAML authentication
  manualLoginPath: '/manual-login', // URL for the manual login page
  roles: {
    READ_ONLY: 'ReadOnly',
    POWER_USER: 'PowerUser',
    INVENTORY_VIEWER: 'InventoryViewer',
    FINANCIALS_VIEWER: 'FinancialsViewer',
    INVENTORY_SENSITIVE_VIEWER: 'InventorySensitiveViewer',
    COMPLIANCE_USER: 'ComplianceUser',
    ADMIN: 'Admin',
    SUPER_ADMIN: 'SuperAdmin',
    // Legacy aliases (backward compatibility)
    USER: 'ReadOnly',
    SYS_ADMIN: 'SuperAdmin'
  }
};
